"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _spinner = _interopRequireDefault(require("../../../elements/other/spinner"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const WidgetContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "WidgetContainer",
  class: "pl-w1qujvfy",
  vars: {
    "w1qujvfy-0": [({
      width
    }) => width ? `${width}px` : '100%'],
    "w1qujvfy-1": [({
      height
    }) => height ? `${height}px` : '100%']
  }
});
const AuctionIframe = /*#__PURE__*/(0, _react2.styled)("iframe")({
  name: "AuctionIframe",
  class: "pl-ajran0q",
  vars: {
    "ajran0q-0": [({
      width
    }) => width ? `${width}px` : '100%'],
    "ajran0q-1": [({
      height
    }) => height ? `${height}px` : '100%']
  }
});

/**
 * AuctionWidget Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Id of the iframe
 * @param {String} props._name Tracking Name of the iframe
 * @param {String} props.auctionTitle Title of the iframe
 * @param {String} props.isc Isc parameter for the iframe
 * @param {String} props.errorPageContent Error message to display when iframe fails to load
 * @param {String} props.overwriteUrl Overwrite the default url of the iframe
 * @returns {React.ReactElement} AuctionWidget Component
 * @public
 */

function AuctionWidget({
  id,
  _name,
  auctionTitle,
  isc,
  errorPageContent,
  overwriteUrl
}) {
  const [iframeLoaded, setIframeLoaded] = (0, _react.useState)(false);
  const [iframeError, setIframeError] = (0, _react.useState)(false);
  const {
    width: windowSize
  } = (0, _patternLibraryUtils.useWindowSize)();
  const iframeRef = (0, _react.useRef)(null);
  const env = (0, _patternLibraryUtils.getDefaultEnv)();
  const effectiveEnv = env === 'prod' ? '' : `${env}-`;
  const auctionBaseUrl = `https://auctions.${effectiveEnv}godaddy.com`;
  const iframeSize = windowSize >= _patternLibraryUtils.size.tablet ? '728x90' : '300x250';
  const height = windowSize >= _patternLibraryUtils.size.tablet ? '91' : '275';
  const width = windowSize >= _patternLibraryUtils.size.tablet ? '728' : '300';
  const constructIframeUrl = (baseUrl, params) => {
    if (typeof window !== 'undefined') {
      const url = new URL(baseUrl);
      Object.keys(params).forEach(key => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
      return url.toString();
    }
    return '';
  };
  const baseUrl = `${auctionBaseUrl}/beta/external/ending_soon`;
  const params = {
    isc,
    size: windowSize > 0 ? iframeSize : null
  };
  const iframeUrl = constructIframeUrl(overwriteUrl || baseUrl, params);
  _patternLibraryUtils.tracking.useTracking(iframeRef);
  const trackingProps = _patternLibraryUtils.tracking.props(`${_name}-iframe`, false, true);
  (0, _react.useEffect)(() => {
    let didCancel = false;
    fetch(iframeUrl, {
      mode: 'no-cors'
    }).then(() => {
      if (!didCancel) {
        setIframeLoaded(true);
      }
    }).catch(() => {
      if (!didCancel) {
        setIframeError(true);
      }
    });
    return () => {
      didCancel = true;
    };
  }, [iframeUrl]);
  return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
    "data-cy": "auction-widget",
    height: height,
    width: width
  }, !iframeLoaded && !iframeError && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    _name: `${_name}_spinner`,
    className: "spinner"
  }), iframeError && errorPageContent && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "error-content"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    emphasis: "critical",
    size: 0
  }, errorPageContent)), iframeLoaded && !iframeError && /*#__PURE__*/_react.default.createElement(AuctionIframe, (0, _extends2.default)({
    id: `id-${id}-auction-iframe`,
    ref: iframeRef,
    title: auctionTitle,
    src: iframeUrl,
    width: width,
    height: height,
    loading: "lazy",
    onLoad: () => setIframeLoaded(true)
  }, trackingProps)));
}
var _default = exports.default = AuctionWidget;
AuctionWidget.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  auctionTitle: _propTypes.default.string,
  isc: _propTypes.default.string,
  errorPageContent: _propTypes.default.string,
  overwriteUrl: _propTypes.default.string
};